
import { PUBLIC_ESTATE_FILTERS } from '../constants';
import { GET } from '../api';

import defineParamsPopulate from './defineParamsPopulate';

import type { StrapiDeveloper } from '@monoimin/sb-types';

export async function getStrapiDevelopers({
  pagination,
  populate,
}: {
  pagination?: { page: number; pageSize: number };
  populate?: string[] | object;
} = {}): Promise<{ developers: StrapiDeveloper[]; totalCount: number }> {
  const { data } = await GET(`/developers`, {
    params: {
      query: {
        'pagination[page]': pagination?.page,
        'pagination[pageSize]': pagination?.pageSize,
        populate: defineParamsPopulate(populate),
        filters: {
          estates: PUBLIC_ESTATE_FILTERS,
        },
        sort: 'title:asc',
      },
    },
  });

  return {
    developers: data?.data ?? [],
    totalCount: data?.meta?.pagination?.total ?? 0,
  };
}

export default getStrapiDevelopers;
